module.exports = "/_next/static/resources/photo-3-ad9ef32bf148056876319f844314793d.webp";